import { ROLEPLAY_DEBRIEF_SETTLED_WITHIN_MS } from '@wundo/shared/roleplay.ts';

/** How often a session whose feedback is being written is asked whether it is done. */
export const DEBRIEF_POLL_MS = 2_000;

/**
 * How long the screen waits on the feedback before it calls it failed: a
 * minute past the point where the server has settled it or lost it, so trying
 * again is always accepted.
 */
export const DEBRIEF_WAIT_LIMIT_MS = ROLEPLAY_DEBRIEF_SETTLED_WITHIN_MS + 60_000;
